'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _icons = require('./icons.css');

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Network = function Network() {
  var ua = navigator.userAgent.toLowerCase();
  var safari = false;
  if (ua.indexOf('safari') !== -1) {
    if (ua.indexOf('chrome') > -1) {
      safari = false;
    } else {
      safari = true;
    }
  }

  return _react2.default.createElement(
    'svg',
    { viewBox: '0 0 559 420', className: _icons2.default.network },
    _react2.default.createElement(
      'g',
      { id: 'Stroke-1' },
      _react2.default.createElement(
        'linearGradient',
        { id: 'SVGID_1_', gradientUnits: 'userSpaceOnUse', x1: '-678.5699', y1: '749.8902', x2: '-678.0634', y2: '749.3406', gradientTransform: 'matrix(556.1981 0 0 -417.1268 377536.125 312934.6562)' },
        _react2.default.createElement('stop', { offset: '0', style: { stopColor: '#F09420' } }),
        _react2.default.createElement('stop', { offset: '1', style: { stopColor: '#E32365' } })
      ),
      _react2.default.createElement('path', { className: 'st0', style: { fill: safari ? '#F09420' : 'url(#SVGID_1_)' }, d: 'M520.9,418.8l-0.9-0.5c25.3-41.9,37.1-86,37.1-138.7c0-74.2-28.9-143.9-81.3-196.3 C423.4,30.8,353.7,1.9,279.5,1.9c-74.1,0-143.9,28.9-196.3,81.3C30.8,135.7,1.9,205.4,1.9,279.6c0,51.3,12.2,96.7,37.2,138.7 l-0.9,0.5C13.1,376.6,0.9,331,0.9,279.6c0-74.4,29-144.4,81.6-197c52.6-52.6,122.6-81.6,197-81.6s144.4,29,197,81.6 c52.6,52.6,81.6,122.6,81.6,197C558.1,332.5,546.3,376.8,520.9,418.8z' })
    ),
    _react2.default.createElement(
      'g',
      { id: 'Stroke-5' },
      _react2.default.createElement(
        'linearGradient',
        { id: 'SVGID_2_', gradientUnits: 'userSpaceOnUse', x1: '-678.6638', y1: '749.9929', x2: '-677.9695', y2: '749.2396', gradientTransform: 'matrix(554.6087 0 0 -417.2686 376456.9375 313041.6875)' },
        _react2.default.createElement('stop', { offset: '0', style: { stopColor: '#F09420' } }),
        _react2.default.createElement('stop', { offset: '1', style: { stopColor: '#E32365' } })
      ),
      _react2.default.createElement('path', { className: 'st1', style: { fill: safari ? '#F09420' : 'url(#SVGID_2_)' }, d: 'M520.3,419.6l-58.9-35.8l0.5-0.9l58.9,35.8L520.3,419.6z M40.7,419.6l-0.5-0.9l58.6-35.6l0.5,0.9L40.7,419.6z M12.7,353.2l-0.3-1l65.4-19.9l0.3,1L12.7,353.2z M548,353.1l-65.4-19.9l0.3-1l65.4,19.9L548,353.1z M3,280.9l0-1l67.8-2l0,1 L3,280.9z M557.6,280.7l-67.8-2l0-1l67.8,2L557.6,280.7z M77.8,224.5L13,206.2l0.3-1l64.8,18.3L77.8,224.5z M482.9,224.4l-0.3-1 l64.8-18.3l0.3,1L482.9,224.4z M98.6,173.7l-55.9-34.3l0.5-0.9l55.9,34.3L98.6,173.7z M462.1,173.5l-0.5-0.9l55.9-34.3l0.5,0.9 L462.1,173.5z M131.8,130l-46-46.7l0.7-0.7l46,46.7L131.8,130z M428.8,129.8l-0.7-0.7l46-46.7l0.7,0.7L428.8,129.8z M175.2,96.4 l-33-57.4l0.9-0.5l33,57.4L175.2,96.4z M385.5,96.2l-0.9-0.5l33-57.4l0.9,0.5L385.5,96.2z M225.7,75.2l-15.1-63.3l1-0.2L226.7,75 L225.7,75.2z M335,75l-1-0.2l15.1-63.3l1,0.2L335,75z M280.7,67.3l-1,0L280,1.9l1,0L280.7,67.3z' })
    ),
    _react2.default.createElement(
      'g',
      { id: 'Stroke-3' },
      _react2.default.createElement(
        'linearGradient',
        { id: 'SVGID_3_', gradientUnits: 'userSpaceOnUse', x1: '-665.1021', y1: '744.5103', x2: '-658.8943', y2: '739.8356', gradientTransform: 'matrix(37.7063 0 0 -37.6949 25215.5918 28245.875)' },
        _react2.default.createElement('stop', { offset: '0', style: { stopColor: '#F09420' } }),
        _react2.default.createElement('stop', { offset: '1', style: { stopColor: '#E32365' } })
      ),
      _react2.default.createElement('path', { className: 'st2', style: { fill: safari ? '#F09420' : 'url(#SVGID_3_)' }, d: 'M274.2,304.2c-10.7,0-19.4-8.7-19.4-19.3s8.7-19.3,19.4-19.3c10.7,0,19.4,8.7,19.4,19.3 S284.9,304.2,274.2,304.2z M274.2,266.5c-10.1,0-18.4,8.2-18.4,18.3c0,10.1,8.2,18.3,18.4,18.3c10.1,0,18.4-8.2,18.4-18.3 C292.5,274.7,284.3,266.5,274.2,266.5z' })
    ),
    _react2.default.createElement(
      'g',
      { id: 'Stroke-7', className: _icons2.default.needle },
      _react2.default.createElement(
        'linearGradient',
        { id: 'SVGID_4_', gradientUnits: 'userSpaceOnUse', x1: '329.6878', y1: '447.0977', x2: '482.6583', y2: '47.0191', gradientTransform: 'matrix(2.311631e-02 -0.9997 0.9997 2.311631e-02 68.0154 631.1551)' },
        _react2.default.createElement('stop', { offset: '0', style: { stopColor: '#F09420' } }),
        _react2.default.createElement('stop', { offset: '1', style: { stopColor: '#E32365' } })
      ),
      _react2.default.createElement('path', { style: { fill: safari ? '#F09420' : 'url(#SVGID_4_)' }, d: 'M304.5,287.7c-0.4,16-14.4,28.8-31.3,28.4c-14.9-0.3-27.3-10.7-29.6-24.7L239.1,88l1-0.2 c2.6,7.7,63.4,188.6,64.1,194.8C304.2,282.8,304.5,286,304.5,287.7z M240.2,91.3l4.5,200c2.2,13.4,14.2,23.5,28.6,23.8 c16.3,0.4,29.9-11.9,30.3-27.4c0-1.6-0.4-4.9-0.4-4.9l0,0C302.5,277.2,248.4,115.9,240.2,91.3z' })
    )
  );
};

exports.default = Network;


//////////////////
// WEBPACK FOOTER
// ./src/components/Technical/Network.js
// module id = 337
// module chunks = 1